<template>
    <div class="treeselect-wrapper">
      <treeselect
        class="hidden-values"
        :multiple="true"
        :flat="false"
        :options="treeselectOptions"
        :value="internalValue"
        :normalizer="normalizer"
        :disable-branch-nodes="false"
        :default-expand-level="0"
        :show-count="true"
        :searchable="false"
        :placeholder="placeholder"
        :append-to-body="true"
        :expanded.sync="expandedNodes"
        @input="onInput"
      />
      <!-- поверх компонента выводим наши метки -->
      <div class="custom-label-overlay">
        {{ summarizedLabels }}
      </div>
    </div>
  </template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'PeriodTreeSelectNew',
  components: { Treeselect },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    treeData: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Выберите период'
    }
  },
  data() {
    return {
      internalValue: [],
      expandedNodes: ['months']
    };
  },
  watch: {
    value(val) {
      this.internalValue = val.slice();
    },
    treeData: {
      immediate: true,
      handler(newVal) {
        this.expandedNodes = ['months'];
      }
    }
  },
  computed: {
    treeselectOptions() {
      return this.convertToTreeselect(this.treeData);
    },
    summarizedLabels() {
        const labels = this.getLabels(this.internalValue);
        if (labels.length <= 2) {
        return labels.join(', ');
        } else {
        return `${labels.slice(0, 2).join(', ')} и ещё ${labels.length - 2}`;
        }
    }
  },
  methods: {
    convertToTreeselect(data) {
      return data.map(item => {
        const node = {
          id: item.id || item.name || item.key || item.display,
          label: item.display || item.text || item.label || item.name,
          children: item.children ? this.convertToTreeselect(item.children) : undefined,
          isDisabled: item.disabled || false
        };
        return node;
      });
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        children: node.children
      };
    },
    onInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
    getLabels(ids) {
        const findLabel = (nodes, id) => {
            for (const node of nodes) {
            if (node.id === id) return node.label;
            if (node.children) {
                const label = findLabel(node.children, id);
                if (label) return label;
            }
            }
            return '';
        };

        return ids.map(id => findLabel(this.treeselectOptions, id)).filter(Boolean);
    }
  }
};
</script>

<style>
.vue-treeselect__multi-value-item-container {
  display: none !important;
}
</style>

<style scoped>
.treeselect {
  min-width: 250px;
}
.treeselect__multi-value {
  display: none !important;
}
.custom-labels {
  margin-top: 5px;
  font-size: 14px;
  color: #555;
}
.treeselect__multi-value {
  display: none !important;
}
.value-summary {
  padding-left: 4px;
  color: #333;
  font-size: 14px;
}
.treeselect-wrapper {
  position: relative;
  width: 100%;
}
.hidden-values ::v-deep(.treeselect__multi-value) {
  display: none !important;
}
.custom-label-overlay {
  position: absolute;
  left: 12px;
  top: 8px;
  font-size: 14px;
  color: #333;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}
</style> 